export default __webpack_public_path__ + "static/media/prj5.c91c1e0a.png";